import React, {
  useMemo, useState, forwardRef
} from 'react';
import { Form, Title } from 'components/atoms';
import { Formik, Field } from 'formik';
import {
  FieldArrayDndFormik, FieldCustom, FieldMarkdown
} from 'components/molecules';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useFormikForwardRef } from 'hooks'
import { useDebounce } from 'react-use'
import { generateKey } from 'services/generators'

const ItemSchema = Yup.object().shape({
  text: Yup.string().required('Campo obrigatório'),
  list: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required('Campo obrigatório'),
        subTitle: Yup.string().required('Campo obrigatório'),
        text: Yup.string().required('Campo obrigatório')
      })
    ).required('A lista deve ter pelo menos um item')
});
const warningSchema = Yup.object().shape({
  title: Yup.string().required('Campo obrigatório'),
  subTitle: Yup.string().required('Campo obrigatório'),
  text: Yup.string().required('Campo obrigatório')
});

// eslint-disable-next-line react/prop-types
const ItemFormItem = forwardRef(({ initialValues, onSubmit }, ref) => {
  // this is necessary for all FieldArrayDnd forms
  // in order to control the submitForm from parent
  const formRef = useFormikForwardRef(ref);

  const initialValuesComputed = useMemo(() => initialValues, [initialValues])


  return (
    <Formik
      ref={formRef}
      initialValues={initialValuesComputed}
      validationSchema={warningSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      validateOnMount
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          info="Uma frase para secção"
          component={FieldCustom}
          maxLetters={50}
        />
        <Field
          title="antetítulo"
          name="subTitle"
          info="Uma frase para secção"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          title="texto do aviso"
          name="text"
          info="Uma frase para secção"
          component={FieldMarkdown}
          maxLetters={300}
        />
      </Form>
    </Formik>
  )
})
// eslint-disable-next-line react/prop-types
const ItemForm = forwardRef(({ initialValues, onSubmit }, ref) => {
  // this is necessary for all FieldArrayDnd forms
  // in order to control the submitForm from parent
  const formRef = useFormikForwardRef(ref);

  const initialValuesComputed = useMemo(() => initialValues, [initialValues])


  return (
    <Formik
      ref={formRef}
      initialValues={initialValuesComputed}
      validationSchema={ItemSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      validateOnMount
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="text"
          info="Uma frase para secção"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          name="list"
          component={FieldArrayDndFormik}
          columns={[
            {
              accessor: 'title',
              Header: 'Título',
            }
          ]}
          rowKey={(item) => generateKey(item.title)}
          ItemForm={ItemFormItem}
        />
      </Form>
    </Formik>
  )
})


const Schema = Yup.object().shape({
  title: Yup.string().required('Campo obrigatório')
});


const SubWebWarnings = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)

  const initialValues = useMemo(() => {
    const {
      tabs, data, ...values
    } = initialProps;
    const list = data.map((item) => {
      const elem = tabs.find(element => element.id === item.id);
      return { ...item, ...elem }
    })
    return {
      list,
      ...values,
      hasLink: false
    };
  }, [initialProps]);


  const handleFormChange = newValues => {
    const {
      title, list, ...values
    } = newValues

    const tabs = list.map((item, index) => {
      const { text } = item
      return { id: index + 1, text }
    })
    const data = list.map((item, index) => {
      const { list } = item
      return { id: index + 1, list }
    })


    const newProps = {
      ...initialProps,
      ...values,
      hasLink: false,
      title,
      data,
      tabs
    }

    const isValid = Schema.isValidSync(newProps)
    if (isValid) setEditorProps(newProps)
  };

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Schema}
      validate={handleFormChange}
      enableReinitialize
    >
      <Form>
        <Title as="h3">Conteúdos</Title>
        <Field
          title="Título"
          name="title"
          info="Uma frase para secção"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          name="list"
          newItemText="Nova categoria"
          component={FieldArrayDndFormik}
          columns={[
            {
              accessor: 'text',
              Header: 'Título',
            }
          ]}
          rowKey={(item) => generateKey(item.id)}
          ItemForm={ItemForm}

        />

      </Form>
    </Formik>
  );
};

SubWebWarnings.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    data: PropTypes.array,
    tabs: PropTypes.array,
    title: PropTypes.string
  }),
};

SubWebWarnings.defaultProps = {
  initialProps: {}
};

export default SubWebWarnings;
